import React, { useEffect, useRef, useState, useCallback } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Breadcrumb, Layout, Menu, theme, Dropdown, Space } from "antd";
import { Footer } from "antd/es/layout/layout";
import "./App.styl";
import {
  getLableByPath,
  routerPath,
  parentLabel,
  childrenLabel,
  getRouterConfig,
  getSelectedKeyByPath,
} from "./router/config";
import { UserOutlined } from "@ant-design/icons";
import { getStorageValByKey, STORAGE_KEY } from "./utils/storage";
import { addLogoutListner, removeLogoutListner } from "./utils/notification";
import { resetLoginInfo } from "./utils/common";
const { Header, Content, Sider } = Layout;

export const App = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const navigate = useNavigate();
  const [breadStr, setBreadStr] = useState("smartBeans/smartBeansSearch");
  const [selectedKeys, setSelectedKeys] = useState(["smartBeansSearch"]);

  const routerConfigInfo = useRef([]);

  useEffect(() => {
    const token = getStorageValByKey(STORAGE_KEY.token);
    if (token > "") {
      navigate(routerPath.smartBeansSearch);
    } else {
      navigate(routerPath.login);
    }
    addLogoutListner(onLogout);

    return removeLogoutListner;
  }, []);

  const path = useLocation();
  useEffect(() => {
    if (!path) return;
    const routerPath = getLableByPath(path.pathname);
    routerPath && setBreadStr(routerPath);

    const selectedkey = getSelectedKeyByPath(path.pathname);
    setSelectedKeys([selectedkey]);
  }, [path]);

  const onLogout = useCallback(() => {
    routerConfigInfo.current = [];
    navigate(routerPath.login);
    resetLoginInfo();
  }, []);

  if (routerConfigInfo.current.length < 1) {
    const permissionIdList = getStorageValByKey(STORAGE_KEY.permissionList);
    routerConfigInfo.current = getRouterConfig(permissionIdList);
  }
  console.log("routerConfigInfo.current:", routerConfigInfo.current);

  const items = [
    {
      label: "退出登录",
      key: "1",
    },
  ];
  return (
    <Layout>
      <Header className="appHeader">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            alignItems: "center",
          }}
        >
          <img
            width="32px"
            height="32px"
            src={require("./assets/images/common/logo.png")} //"https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
            alt="logo"
          />
          <h1 className="headerName">智慧豆管理平台</h1>
        </div>
        <div style={{ marginRight: 50 }}>
          <Dropdown
            menu={{
              items,
              onClick: (e) => {
                onLogout();
              },
            }}
            onOpenChange={(e) => {}}
          >
            <a
              onClick={(e) => {
                // navigate(routerPath.login);
              }}
            >
              <Space>
                <UserOutlined />
                {getStorageValByKey(STORAGE_KEY.nickName)}
              </Space>
            </a>
          </Dropdown>
        </div>
      </Header>
      <Layout>
        <Sider width={200}>
          {Array.isArray(routerConfigInfo.current) == false ? null : (
            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              defaultSelectedKeys={["smartBeansSearch"]}
              defaultOpenKeys={["smartBeans"]}
              style={{
                height: "100%",
                borderRight: 0,
              }}
              items={routerConfigInfo.current || []}
              onClick={(item) => {
                const key = item.key;
                const path = routerPath[key];
                if (path > "") {
                  navigate(path);
                }
                if (item.keyPath.length > 0) {
                  item.keyPath.reverse();
                  setBreadStr(item.keyPath.join("/"));
                }
              }}
            />
          )}
        </Sider>
        <Layout
          style={{
            padding: "0 24px 24px",
          }}
        >
          <Breadcrumb
            style={{
              margin: "16px 0",
            }}
          >
            {breadStr.split("/").map((item, index) => {
              return (
                <Breadcrumb.Item key={index}>
                  {parentLabel[item] || childrenLabel[item]}
                </Breadcrumb.Item>
              );
            })}
          </Breadcrumb>
          <Content
            style={{
              paddingBottom: 24,
              margin: 0,
              background: "#99999",
              borderRadius: borderRadiusLG,
            }}
          >
            <Outlet />
          </Content>
          <Footer className="footerContainer">必经之路</Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};
